export default __webpack_public_path__ + "static/media/steam.d12a2ca2.ico";